export interface CustomUserDropdownItem {
  label: string;
  url?: string;
  route?: string;
  callback?: () => void;
  eventId?: string;
}

export interface IdentifiableCustomUserDropdownItem extends CustomUserDropdownItem {
  id: string;
}

export function isIdentifiable(
  item: CustomUserDropdownItem | IdentifiableCustomUserDropdownItem,
): item is IdentifiableCustomUserDropdownItem {
  return 'id' in item && typeof item.id === 'string' && item.id !== '';
}
